import React from 'react';
import './index.css';

const EmailInvoiceTemplate = ({ invoiceData, bookingData, businessProfile }) => {

  var taxableValue = bookingData && bookingData.paymentDetails && (bookingData.paymentDetails.amountReceived - (parseFloat(bookingData.paymentDetails.amountReceived) * parseFloat(bookingData.taxRate)) / 100);
  var taxValue = bookingData && bookingData.paymentDetails && ((parseFloat(bookingData.paymentDetails.amountReceived) * parseFloat(bookingData.taxRate)) / 100);
  var totalValue = parseFloat(taxableValue) + parseFloat(taxValue);

  return (
    <div style={{ width: 600, fontSize: '0.875rem', marginBottom: 'auto', marginLeft: 'auto', marginRight: 'auto' }}>
      <div style={{ marginBottom: 32, paddingTop: 32 }}>
        <h2 style={{ marginBottom: 0 }}>Hi, {bookingData && bookingData.partyDetails && bookingData.partyDetails.partyName},</h2>
        <div style={{ marginBottom: 0, textAlign: 'justify' }}>Thank you for your prompt payment. We value your trust in our services and look forward to serving you again.</div>
      </div>
      <div style={{ background: 'rgb(250, 250, 250)', border: '1px solid rgb(204, 204, 204)', borderRadius: 6, boxShadow: 'rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px' }}>
        <div style={{ textAlign: 'center', background: 'linear-gradient(90deg, rgba(93,114,228,1) 0%, rgba(50,76,221,1) 100%)', marginLeft: 16, marginRight: 16, padding: 8, borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}>
          <h2 style={{ color: '#ffffff', marginBottom: 0, marginTop: 0 }}>#{bookingData && bookingData.invoiceNumber}</h2>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
          <div style={{ width: '50%', padding: 16, paddingBottom: 0 }}>
            <h4 style={{ marginBottom: 8, fontWeight: '400', textTransform: 'uppercase', color: 'rgb(128,128,128)' }}>Invoice to</h4>
            <div style={{ fontWeight: '600', marginBottom: 0 }}>{bookingData && bookingData.partyDetails.partyName}</div>
            <div style={{ marginBottom: 0 }}>{bookingData && bookingData.partyDetails.address + ','}</div>
            <div style={{ marginBottom: 0 }}>{bookingData && bookingData.partyDetails.city + ','} {bookingData && bookingData.partyDetails.bookingData + ','} {bookingData && bookingData.partyDetails.pincode}</div>
            <div>+91 {bookingData && bookingData.partyDetails.phoneNumber}</div>
          </div>
          <div style={{ width: '50%', padding: 16, paddingBottom: 0, textAlign: 'end' }}>
            <h4 style={{ marginBottom: 8, fontWeight: '400', textTransform: 'uppercase', color: 'rgb(128,128,128)' }}>Invoice from</h4>
            <div style={{ fontWeight: '600', marginBottom: 0 }}>{businessProfile && businessProfile.businessName}</div>
            <div style={{ marginBottom: 0 }}>{businessProfile && businessProfile.address + ','}</div>
            <div style={{ marginBottom: 0 }}>{businessProfile && businessProfile.city + ','} {businessProfile && businessProfile.bookingData + ','} {businessProfile && businessProfile.pincode}</div>
            <div>+91 {businessProfile && businessProfile.phoneNumber}</div>
          </div>
        </div>
        <hr />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16 }}>
          <h4 style={{ width: '50%', fontWeight: '400', marginBottom: 0, marginTop: 0, color: 'rgb(128,128,128)' }}>Booking Date</h4>
          <div style={{ width: '50%', marginBottom: 0, textAlign: 'end' }}>{bookingData && bookingData.bookingDate && new Date(bookingData.bookingDate.seconds * 1000).toDateString()}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16 }}>
          <h4 style={{ width: '50%', fontWeight: '400', marginBottom: 0, marginTop: 0, color: 'rgb(128,128,128)' }}>Due Date</h4>
          <div style={{ width: '50%', marginBottom: 0, textAlign: 'end' }}>{bookingData && bookingData.paymentDetails && new Date(bookingData.paymentDetails.dueDate.seconds * 1000).toDateString()}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16 }}>
          <h4 style={{ width: '50%', fontWeight: '400', marginBottom: 0, marginTop: 0, color: 'rgb(128,128,128)' }}>Invoice Date</h4>
          <div style={{ width: '50%', marginBottom: 0, textAlign: 'end' }}>{bookingData && bookingData.paymentDetails && bookingData.paymentDetails.paymentDate ? new Date(bookingData.paymentDetails.paymentDate.seconds * 1000).toDateString() : new Date(bookingData.bookingDate.seconds * 1000).toDateString()}</div>
        </div>
        <hr />
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16 }}>
          <div style={{ width: '70%' }}>
            <h4 style={{ marginTop: 0, marginBottom: 0, fontWeight: '400', color: 'rgb(128,128,128)' }}>Property Description</h4>
            <div style={{ fontWeight: '600', marginBottom: 0, marginTop: 0 }}>
              {bookingData && bookingData.projectDetails && bookingData.projectDetails.propName}
            </div>
            <div style={{ marginBottom: 0 }}>
              {bookingData && bookingData.projectDetails && bookingData.projectDetails.propNumber}
              {bookingData && bookingData.projectDetails && ', ' + bookingData.projectDetails.propCity}
              {bookingData && bookingData.projectDetails && ', ' + bookingData.projectDetails.propbookingData}
              {bookingData && bookingData.projectDetails && ',' + bookingData.projectDetails.propPincode}
            </div>
          </div>
          <div style={{ width: '30%' }}>
            <h4 style={{ marginTop: 0, marginBottom: 0, fontWeight: '400', color: 'rgb(128,128,128)', textAlign: 'end' }}>Unit</h4>
            <div style={{ marginBottom: 0, textAlign: 'end', marginTop: 0 }}>
              {bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitName + ' '}
              ({bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitArea + ' ' + bookingData.projectDetails.propUnitMeasure})
            </div>
          </div>
        </div>
        <hr />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16 }}>
          <div style={{ color: 'rgb(128,128,128)', width: '50%' }}>Taxable Amount</div>
          <div style={{ color: 'rgb(128,128,128)', width: '50%', textAlign: 'end' }}>₹ {taxableValue.toFixed(2)}</div>
        </div>
        {
          bookingData && bookingData.partyDetails && bookingData.projectDetails && bookingData.partyDetails.bookingData !== bookingData.projectDetails.propbookingData ?
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16, marginTop: 8 }}>
              <div style={{ marginBottom: 0, color: 'rgb(128,128,128)', width: '50%' }}>
                IGST @ {bookingData.taxRate}%
              </div>
              <div style={{ marginBottom: 0, color: 'rgb(128,128,128)', width: '50%', textAlign: 'end' }}>
                ₹ {(parseFloat(taxValue)).toFixed(2)}
              </div>
            </div>
            :
            <>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16, marginTop: 8 }}>
                <div style={{ marginBottom: 0, color: 'rgb(128,128,128)', width: '50%' }}>
                  SGST @ {parseFloat(bookingData.taxRate) / 2}%
                </div>
                <div style={{ marginBottom: 0, color: 'rgb(128,128,128)', width: '50%', textAlign: 'end' }}>
                  ₹ {(parseFloat(taxValue) / 2).toFixed(2)}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16 }}>
                <div style={{ marginBottom: 0, color: 'rgb(128,128,128)', width: '50%' }}>
                  CGST @ {parseFloat(bookingData.taxRate) / 2}%
                </div>
                <div style={{ marginBottom: 0, color: 'rgb(128,128,128)', width: '50%', textAlign: 'end' }}>
                  ₹ {(parseFloat(taxValue) / 2).toFixed(2)}
                </div>
              </div>
            </>
        }
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 16, paddingRight: 16, marginTop: 8 }}>
          <h2 style={{ fontWeight: '600', width: '50%', marginTop: 0, marginBottom: 0 }}>Total Amount</h2>
          <h2 style={{ fontWeight: '600', width: '50%', marginTop: 0, marginBottom: 0, textAlign: 'end' }}>₹ {totalValue}</h2>
        </div>
        <hr />
        <div style={{ paddingLeft: 16, paddingRight: 16 }}>
          <h4 style={{ color: 'rgb(128,128,128)', fontWeight: '600', marginBottom: 8, marginTop: 0 }}>Payment Details</h4>
          <div style={{ paddingBottom: 16 }}>
            {
              bookingData && bookingData.paymentDetails.paymentMode === 'Cash' ?
                <div style={{ marginBottom: 0 }}>
                  <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ width: '50%' }}>Paid via </span>
                    <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentMode}</span>
                  </small>
                </div>
                : (bookingData && bookingData.paymentDetails.paymentMode === 'Debit Card') || (bookingData.paymentDetails.paymentMode === 'Credit Card') ?
                  <div style={{ marginBottom: 0 }}>
                    <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ width: '50%' }}>Paid via </span>
                      <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentMode}</span>
                    </small>
                    <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ width: '50%' }}>Reference No. :</span>
                      <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentReferenceNumber}</span>
                    </small>
                  </div>
                  : bookingData && bookingData.paymentDetails.paymentMode === 'Bank' ?
                    <div style={{ marginBottom: 0 }}>
                      <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ width: '50%' }}>Paid via </span>
                        <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentMode === 'Bank' ? 'Bank Transfer' : bookingData.paymentDetails.paymentMode}</span>
                      </small>
                      <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ width: '50%' }}>Account Holder :</span>
                        <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentReceivedFrom && bookingData.paymentDetails.paymentReceivedFrom.accountHolderName}</span>
                      </small>
                      <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ width: '50%' }}>Account Number :</span>
                        <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentReceivedFrom && bookingData.paymentDetails.paymentReceivedFrom.accountNumber}</span>
                      </small>
                    </div>
                    : bookingData.paymentDetails.paymentMode === 'UPI' ?
                      <div style={{ marginBottom: 0 }}>
                        <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <span style={{ width: '50%' }}>Paid via </span>
                          <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentMode === 'Bank' ? 'Bank Transfer' : bookingData.paymentDetails.paymentMode}</span>
                        </small>
                        <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <span style={{ width: '50%' }}>Received from :</span>
                          <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentReceivedFrom && bookingData.paymentDetails.paymentReceivedFrom}</span>
                        </small>
                      </div>
                      : bookingData && bookingData.paymentDetails.paymentMode === 'Cheque' ?
                        <div style={{ marginBottom: 0 }}>
                          <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span style={{ width: '50%' }}>Paid via </span>
                            <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentMode}</span>
                          </small>
                          <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span style={{ width: '50%' }}>Reference No. :</span>
                            <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.paymentReferenceNumber && bookingData.paymentDetails.paymentReferenceNumber}</span>
                          </small>
                          <small style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span style={{ width: '50%' }}>Date of Cheque :</span>
                            <span style={{ width: '50%', textAlign: 'end' }}>{bookingData.paymentDetails.chequeDate && new Date(bookingData.paymentDetails.chequeDate.seconds * 1000).toDateString()}</span>
                          </small>
                        </div>
                        :
                        null
            }
          </div>
        </div>
      </div>
      <div style={{ marginTop: 32, textAlign: 'center' }}>
        <div>
          <small>Design & Developed by</small>
        </div>
        <div>
          <a href='https://www.appzito.com/' target='_blank' rel="noreferrer" alt='appzito-technologies' style={{ textDecorationLine: 'none' }}>Appzito Technologies</a>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', marginTop: 24, width: '100%' }}>
          <a href='https://www.facebook.com/' alt='facebook'>
            <span>Facebook</span>
          </a>
          <a href='https://www.instagram.com/' alt='instagram'>
            <span>Instagram</span>
          </a>
          <a href='https://www.twitter.com/' alt='twitter'>
            <span>Twitter</span>
          </a>
          <a href='https://www.pinterest.com/' alt='pinterest'>
            <span>Pinterest</span>
          </a>
          <a href='https://www.dribble.com/' alt='dribble'>
            <span>Dribble</span>
          </a>
          <a href='https://www.behance.com/' alt='behance'>
            <span>Behance</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default EmailInvoiceTemplate;